import type { PID } from '@fs/zion-tree-types'
import { type SwrResponse, useSwrRequest } from './useSwrRequest'

export type MyHeritageHintDetail = {
  type: string
  name: string
  modifier: string
}

export type MyHeritageHintsResponse = {
  link: string
  totalHints: number
  hintSummaryDetails: MyHeritageHintDetail[]
  factorsDescription?: string
}

const getUrl = (personId: PID): string => `/service/external/hints/myheritage/persons/${personId}/hints`

/**
 * MyHeritage record hints for a person. Shared by the research help card, which lists them, and by
 * the person-page hint summary, which only needs the count — SWR dedupes the two into one request.
 */
export default function useMyHeritageHints({
  personId,
}: {
  personId: PID | undefined
}): SwrResponse<MyHeritageHintsResponse> & { totalHints: number } {
  const response = useSwrRequest<MyHeritageHintsResponse>(personId ? getUrl(personId) : null)

  return { ...response, totalHints: response.data?.totalHints ?? 0 }
}
